import type { TransactionInterface_UNSTABLE, GetRecoilValue } from "recoil"

// Lives in a leaf module (re-exported by ./index) so state files inside the
// elements/phase import cycle can use readonlyTransactors without pulling in
// the full transactions barrel, which evaluates every transaction module.
export type TransactionOperation<ARG = undefined, RETURN = void> = (
  transactors: TransactionInterface_UNSTABLE,
  ...rest: ARG extends undefined ? [] : [argument: ARG]
) => RETURN

export const readonlyTransactors = (
  get: GetRecoilValue,
): TransactionInterface_UNSTABLE => ({
  get,
  set: () => console.warn(`readonlyOperation: set() is not supported`),
  reset: () => console.warn(`readonlyOperation: reset() is not supported`),
})
